import '../../EmptyState.scss';
import Paragraph from 'components/TextComps/Paragraph';
import { useTranslation } from 'react-i18next';
import ImportStudentListButton from '../../Invites/ImportStudentListButton/ImportStudentListButton';
import InviteStudentsButton from '../../Invites/InviteStudentsButton/InviteStudentsButton';

export const NoPendingInvitations = () => {
  const { t } = useTranslation();

  return (
    <div className='no-data-found'>
      <h2>{t('NoPendingInvitations', { ns: 'studentsPage' })}</h2>
      <Paragraph>
        <>{t('InviteStudentsAndCheckBack', { ns: 'studentsPage' })}</>
      </Paragraph>
      <div className='buttons-wrapper'>
        <ImportStudentListButton intent='secondary' />
        <InviteStudentsButton intent='secondary' />
      </div>
    </div>
  );
};
